const messages = {
    en: {
      accountSettings: "Account settings",
      setCurrentLanguage: "Set current langusage",
      wantToSeeHints: "Want to see correct answer hints while testing",
      ifYesHints: "If yes, after you clicked answer while testing, correct anser will be outlined in green for several seconds",
      changePassword: "Change password",
      pleaseKeepInMind: "Please keep in mind that after succesful password change stystem will log you out and you will need to use your new password to log in again.",
      submit: "Submit",
      clearValues: "Clear values",
      enterNewPassw: "Enter new password",
      repeatNewPassw: "Repeat new password",
      required: "Required",
      mustBe8CharOrMore: "Must be 8 characters or more",
      mustBe15CharactersOrLess: 'Must be 15 characters or less',
      passwordsDoNotMatch: 'Passwords do not match',

    },
    ru: {
      accountSettings: "Настройки учетной записи",
      setCurrentLanguage: "Установить текущий язык",
      wantToSeeHints: "Хотите видеть подсказки при тестировании",
      ifYesHints: "Если да, то после того как вы нажали ответ во время тестирования, правильный ответ будет обведен зеленой рамкой на несколько секунд.",
      changePassword: "Cменить пароль",
      pleaseKeepInMind: "Имейте в виду, что после успешной смены пароля система выйдет из сессии, и вам нужно будет использовать новый пароль для повторного входа.",
      submit: "Oтправить",
      clearValues: "Очистить формy",
      enterNewPassw: "Введите новый пароль",
      repeatNewPassw: "Повторите новый пароль",
      required: "Oбязательный",
      mustBe8CharOrMore: "Должно быть 8 или более символов",
      mustBe15CharactersOrLess: "Должно быть не более 15 символов",
      passwordsDoNotMatch: 'Пароли не соответствуют',
    }
  };

  export default messages;

